import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJAIImageList from '../view/FJAIImageList.jsx';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJConfig from '../../../../config/FJConfig.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
import useAIListSideModelData from '../../../../hooks/useAIListSideModelData.jsx';
import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub.js';

const FJAIImageListContainer = ({ position }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const { list, isShow, closeModal } = useAIListSideModelData();

    const itemClick = useCallback((info, curMenuIndex) => {
        switch (FJConfig.appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR:
                dispatch(FJActionAIVideoGenerator.useAIImageAction(info, curMenuIndex));
                break;
            case FJAppConstant.AI_VIDEO_DUB:
                dispatch(FJActionAiVideoDub.useAIImageAction(info, curMenuIndex));
                break;
            default:
        }
    }, []);

    return (
        <FJAIImageList active={isShow} closeModal={closeModal} list={list} itemClick={itemClick} position={position} />
    );
};

export default FJAIImageListContainer;
